/**
 * X-Acting-For başlığının EKLENECEĞİ yollar — sunucudaki [SessionAuthorize(AllowDelegation)]
 * listesinin istemci aynası.
 *
 * Başlık önceden HER isteğe gidiyordu; vekalete kapalı uçlar tasarım gereği 403 döndüğü için
 * owner vekaletteyken alakasız ekranlar da kırılıyordu: /hesabim "grubun yok" sanıp teklif
 * gösterdi (my-grant/üyelik çağrıları 403), yükleyicinin belge tipi listesi öldü
 * (standard-documents 403). Başlık artık yalnız vekalet GÖREVİNİN uçlarına gider; uygulamanın
 * kalanı aktörün kendi kimliğiyle normal çalışır.
 *
 * Sunucu varsayılan-red yine güvenlik ağı: bu liste yanlışlıkla genişlerse istek sessizce
 * yanlış kişiye gitmez, açıkça 403 alır. Yeni bir uç vekalete açıldığında İKİ yer güncellenir:
 * sunucuda AllowDelegation, burada desen.
 */
export const DELEGATED_PATH_PATTERNS = [
  // Başvuru Formu (Kişisel Bilgiler) — pasif üyenin formunu owner doldurur. Sunucu FULL kapsam
  // şartı koyar; İK–aktif çalışan (Status) 403 alır. Hesap self-servisi (oturumlar, KVKK, silme)
  // aynı ön ekte olsa da vekalete KAPALI, o yüzden desen TAM eşleşme.
  /^\/api\/profile$/,
  /^\/api\/profile\/photo$/,
  /^\/api\/documents$/,                                // üyenin belge listesi
  /^\/api\/documents\/(upload|upload-standard|link-existing)$/,
  /^\/api\/documents\/\d+$/,                           // üye belgesini silme
  // YALNIZ progress: matrix / summary / remind sunucuda vekalete KAPALI. Geniş `groups/`
  // deseni onlara da başlık ekliyordu ve vekalet açıkken hepsi 403 dönüyordu.
  /^\/api\/documents\/groups\/[^/]+\/progress$/,
  /^\/api\/countries\/[^/]+\/standard-documents$/,     // yükleyici tip listesi (üyenin hasPaid'i)
  // Amaç/eğitim klasörleri de öznenin hakkıyla okunmalı. Başlık gitmediğinde uç OWNER
  // kimliğiyle çalışıyordu ve owner ödemesizse "tamamen premium" liste BOŞ dönüyordu —
  // ekranda yalnız Standart Belgeler görünüyor, diğer klasörler hiç çıkmıyordu.
  /^\/api\/countries\/[^/]+\/purpose-documents$/,
  /^\/api\/countries\/[^/]+\/education-documents$/,
  /^\/api\/payment-service\/user-history/,             // üyenin erişim/paket durumu (K7)
  // Analiz üçlüsü — pasif üye giremediği için analizini owner koşar (sunucu FULL kapsam şartı
  // koyar; Status/İK 403 alır). Sonuç ve seçim kaydı ÖZNEYE (üyeye) yazılır/okunur.
  /^\/api\/documents\/analyze$/,
  /^\/api\/documents\/analysis-status$/,
  /^\/api\/documents\/save-selection$/,
];

export const shouldSendActingFor = (url = '') => {
  const path = String(url).split('?')[0];
  return DELEGATED_PATH_PATTERNS.some((pattern) => pattern.test(path));
};
